/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Save_To_Space_File_ScreenshotInputs */



/**
* | output |
* | --- |
* | "File: a browser screenshot from this chat" |
*
* @param {Chat_Save_To_Space_File_ScreenshotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_file_screenshot = /** @type {((inputs?: Chat_Save_To_Space_File_ScreenshotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_File_ScreenshotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei: ein Browser-Screenshot aus diesem Chat")
	return /** @type {LocalizedString} */ ("File: a browser screenshot from this chat")
});